import React from "react";
import { TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import Icons from "@/assets/icons";

type SocialPlatform = "facebook" | "twitter" | "instagram" | "messenger";

type Props = {
  onPress: () => void;
  platform: SocialPlatform;
  size?: number;
};

const getIcon = (platform: SocialPlatform) => {
  switch (platform) {
    case "facebook":
      return Icons.FacebookButton;
    case "twitter":
      return Icons.TwitterButton;
    case "instagram":
      return Icons.InstagramButton;
    case "messenger":
      return Icons.MessengerButton;
    default:
      return Icons.FacebookButton;
  }
};

const SocialMediaButton: React.FC<Props> = ({
  onPress,
  platform,
  size = 60,
}) => {
  const IconComponent = getIcon(platform);

  return (
    <TouchableOpacity
      style={[styles.button, { width: size, height: size }]}
      onPress={onPress}
    >
      <IconComponent width={60} height={60} />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: "#F3F3F3",
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default SocialMediaButton;
